import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useObserver } from 'mobx-react-lite';

import useUser from './use-user';

const GET_USER_SEGMENTS = gql`
  query GetUserSegments($dispensaryId: String!) {
    meConsumer {
      _id
      segmentIds(dispensaryId: $dispensaryId)
    }
  }
`;

export type UseUserSegmentsProps = {
  dispensaryId?: string;
};

export type UseUserSegmentsReturn = {
  segments: string[];
  loading: boolean;
};

// network-only because browser caches GET requests by URL, ignoring auth headers
export function useUserSegments({ dispensaryId }: UseUserSegmentsProps): UseUserSegmentsReturn {
  const User = useUser();
  const isLoggedIn = useObserver(() => User.isLoggedIn);
  const userId = useObserver(() => User.id);

  const { data, loading } = useQuery(GET_USER_SEGMENTS, {
    variables: { dispensaryId: dispensaryId ?? '' },
    skip: !isLoggedIn || !dispensaryId || !userId,
    fetchPolicy: 'network-only',
  });

  const segments = data?.meConsumer?.segmentIds || [];

  return {
    segments,
    loading: isLoggedIn && (loading || !userId),
  };
}
